export default "__VITE_ASSET__BJPZ4s3F__"